import styled from "styled-components";
// import { useState, useEffect } from "react";
// import axios from "axios";

import WelcomeText from "./WelcomeStar";

const media ={
    desktop: '@media (min-width: 800px)',
    mobile: '@media (max-width: 780px)',
    phone: '@media (max-width: 580px)'
    }



function TestPage(state) {
    // const [color, setColor] = useState([])

    const colored = '#'+(0x1000000+Math.random()*0xffffff).toString(16).substr(1,6)
    // const [art,setArt] = useState([])

   

    return(
        <StyledTest >
            <WelcomeText star={colored} />
            <div className="colorBox">
                <div className="Block" style={{background: `${colored}` }} >
                    <p className="un">{ colored}</p>
                </div>
            </div>
        </StyledTest>

    );
}

export default TestPage;

const StyledTest = styled.div`
width: 100%;
height: 90vh;
display: flex ;
justify-content: center ;
align-items: center;
flex-direction: column ;
.Welcome{
    width: 100%;
    height: auto;
    color: #f2f4ff;
  -webkit-user-select: none; /* Safari 3.1+ */
 -moz-user-select: none; /* Firefox 2+ */
 -ms-user-select: none; /* IE 10+ */
 user-select: none; /* Standard syntax */

}

h2{
    margin-bottom: 5%;
}

.colorBox{
    display: flex ;
    justify-content: center ;
    align-items: center;
    height: 65vh;
    width: 100vw;
}

.Block{
    width: 500px;
    height: 500px;
    border-radius: 50%;
    display: flex ;
    justify-content: center ;
    align-items: center;
    /* box-shadow: inset 1% 5% 5% white; */
    box-shadow: inset 0em 0em 1em .6em rgba(255, 255, 255, 0.2), 0em 0em 1em .5em rgba(192, 192, 192, 0.3);
}
${media.phone}{
    .Block{
    width:300px;
    height: 300px; 
    } 
    h2{
        font-size: 1.2rem !important;
    }
    .un{
        font-size: 1.2rem !important;
    }
    span{
        font-size: 1.5rem !important;
    }
    .colorBox{
        height: 70%;
    width: 100%;
    }
}
`